import * as R from "ramda";
import getUrlSeparator from "./getUrlSeparator";
import serializeQuery from "./serializeQuery";
import deserializeQuery from "./deserializeQuery";

function getUrlWithQuery(url, query) {
  let queryObj = {};

  if (typeof query === "string") {
    queryObj = deserializeQuery(query);
  } else if (typeof query === "object") {
    queryObj = query;
  } else {
    return url;
  }

  const nextQuery = R.compose(
    serializeQuery,
    R.reduce((acc, key) => {
      const val = queryObj[key];

      if (R.isEmpty(val) || R.isNil(val)) {
        return acc;
      }

      return {
        ...acc,
        [key]: val,
      };
    }, ""),
    R.keys
  )(queryObj);

  const seperator = nextQuery ? getUrlSeparator(url) : "";

  return `${url}${seperator}${nextQuery}`;
}

export default R.curry(getUrlWithQuery);



// WEBPACK FOOTER //
// ./utils/getUrlWithQuery.js